var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with (null).")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-down",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3828125,16.0546875 C2.92968523,15.5234348 2.8476548,14.9648467 3.13671875,14.3789062 C3.4257827,13.7929658 3.90624664,13.5 4.578125,13.5 L44.328125,13.5 C45.0000034,13.5 45.45703,13.7929658 45.6992187,14.3789062 C45.9414075,14.9648467 45.8359398,15.5234348 45.3828125,16.0546875 L26.6328125,36.609375 C26.0390595,37.2812534 25.289067,37.6171875 24.3828125,37.6171875 C23.476558,37.6171875 22.7265655,37.2812534 22.1328125,36.609375 L3.3828125,16.0546875 Z",
    id: "directdown"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDown);
export default __webpack_public_path__ + "static/media/direct-down.08be2d53995f5eb3e4879bfaa17fc86c.svg";
export { ForwardRef as ReactComponent };